/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import Table from "../../Components/DataTable/Table";
import { useNavigate, useParams } from "react-router-dom";
import { downloadExportedProduct, getExportedProduct, saveDownloadLog, updateExportedData } from "../../Services/ExportDataService";
import BaseModal from "../../Components/BaseModal/BaseModal";
import { Calendar } from 'primereact/calendar';
import Select from 'react-select'
import Swal from "sweetalert2";

const options = [
    { value: '00:00', label: '00:00 AM' },
    { value: '01:00', label: '01:00 AM' },
    { value: '02:00', label: '02:00 AM' },
    { value: '03:00', label: '03:00 AM' },
    { value: '04:00', label: '04:00 AM' },
    { value: '05:00', label: '05:00 AM' },
    { value: '06:00', label: '06:00 AM' },
    { value: '07:00', label: '07:00 AM' },
    { value: '08:00', label: '08:00 AM' },
    { value: '09:00', label: '09:00 AM' },
    { value: '10:00', label: '10:00 AM' },
    { value: '11:00', label: '11:00 AM' },
    { value: '12:00', label: '12:00 PM' },
    { value: '13:00', label: '13:00 PM' },
    { value: '14:00', label: '14:00 PM' },
    { value: '15:00', label: '15:00 PM' },
    { value: '16:00', label: '16:00 PM' },
    { value: '17:00', label: '17:00 PM' },
    { value: '18:00', label: '18:00 PM' },
    { value: '19:00', label: '19:00 PM' },
    { value: '20:00', label: '20:00 PM' },
    { value: '21:00', label: '21:00 PM' },
    { value: '22:00', label: '22:00 PM' },
    { value: '23:00', label: '23:00 PM' },
]

const ListGenerateProductData = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [listData, setListData] = useState([]);
    const [page, setPage] = useState(1);
    const [perpage, setPerpage] = useState(10);
    const [sort, setSort] = useState({ field: 'ms_product_master.id', direction: 'asc' });
    const [configTable, setConfigTable] = useState([]);
    const [configHeader, setConfigHeader] = useState(null);
    const [isLoadingData, setLoadingData] = useState(false);

    const [openModalDownload, setOpenModalDownload] = useState(false);
    const [isDownloading, setDownloading] = useState(false);
    const [uploadingFile, setUploadingFile] = useState(false);

    const [openModalPublish, setOpenModalPublish] = useState(false);
    const [scheduleType, setScheduleType] = useState(null);
    const [scheduleDate, setScheduleDate] = useState(null);
    const [scheduleTime, setScheduleTime] = useState(null);

    const [metaList, setMetaList] = useState({
        current_page: 1,
        from: 1,
        perpage: 10,
        to: 0,
        total: 0,
        total_page: 0
    });

    const fetchDataProduct = () => {
        const params = {
            exported_data_id: id,
            page: page,
            per_page: perpage,
            sort_by: sort.field,
            sort_order: sort.direction
        }
        getExportedProduct(params, (res) => {

            let products = res?.data?.data?.data;
            // console.log(products);

            const newConfigTable = res?.data?.extra_data?.map((item) => {
                const key = item?.title;
                let maxLength = 0;
                if (key && Array.isArray(products)) {
                    products.forEach((product) => {
                        const value = product?.[key];
                        const str = value !== undefined && value !== null ? String(value) : "";
                        if (str.length > maxLength) {
                            maxLength = str.length;
                        }
                    });
                }

                const width = maxLength > 0 ? Math.min(maxLength * 10, 500) : 100;

                return {
                    ...item,
                    sortable: item?.value ? false : true,
                    with_aliases: item?.value ? false : true,
                    width: width
                }
            });

            let additionalConfig = [];

            if(res?.data?.additional_data?.length > 0) {

                products = res?.data?.data?.data?.map((item) => {
                    res?.data?.additional_data?.forEach(field => {
                        item[field.accessor] = field.value;
                    });
                    return item;
                });
            }

            products = products?.map(item => {
                return {
                    ...item,
                    price: parseInt(item?.price)
                }
            })
            // console.log(products);
            
            setListData(products);
            setConfigTable([
                ...(newConfigTable || []),
                ...(additionalConfig || [])
            ]);

            setMetaList({
                ...metaList,
                current_page: res?.data?.data?.current_page,
                from: res?.data?.data?.from,
                perpage: res?.data?.data?.per_page,
                to: res?.data?.data?.to,
                total: res?.data?.data?.total,
                total_page: res?.data?.data?.last_page,
            });

            const headerData = res?.data?.exported_data;
            const newHeaderData = {
                item_status_pmc: headerData?.item_status_pmc === null ? 'All' : headerData?.item_status_pmc ? 'Active' : 'Inactive',
                item_status_website: headerData?.item_status_website === null ? 'All' : headerData?.item_status_website ? 'Active' : 'Inactive',
                form_name: headerData?.form_name,
                item_country: headerData?.is_all_country ? 'All Country' : headerData?.item_country?.join(", "),
                filter_category: headerData?.is_all_category ? 'All Category' : headerData?.filter_category?.join(", ")
            }
            setConfigHeader(newHeaderData);
            setLoadingData(false);
        }, () => {
            setLoadingData(false);
        });

        // setLoadingData(false);
    }

    const toQueryString = (params) => {
        return Object.keys(params)
            .filter(key => params[key] !== undefined && params[key] !== null) // Hapus undefined/null
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`) // Encode nilai
            .join('&');
    };

    const downloadGeneratedData = async () => {
        setDownloading(true);
        const params = {
            exported_data_id: id
        }

        fetch(`${process.env.REACT_APP_URL}v1/admin/export-product-data?${toQueryString(params)}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Ganti dengan token dari storage atau state
            }
        })
            .then(response => response.blob())
            .then(blob => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'exported_products.csv');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                setDownloading(false);
                setOpenModalDownload(false);

                saveDownloadLog(id);
            })
            .catch(error => {
                setDownloading(false);
                setOpenModalDownload(false);
            });
    }

    const onUpdateData = () => {
        let formattedDate = "";
        if (scheduleType === '1') {
            const date = new Date(scheduleDate);
            const options = { year: "numeric", month: "2-digit", day: "2-digit" };

            formattedDate = new Intl.DateTimeFormat("id-ID", options)
                .format(date)
                .split("/")
                .reverse()
                .join("-");
        }

        const formData = {
            published_flag: scheduleType,
            published_date: formattedDate,
            published_time: scheduleTime
        }

        updateExportedData(id, formData, (res) => {
            setOpenModalPublish(false);
            // Swal.fire({
            //     icon: "success",
            //     title: "Update data success",
            //     text: "Data has been updated!",
            // }).then(() => {
            //     setScheduleType("");
            //     setScheduleDate("");
            //     setScheduleTime("");
            // });

            if (res?.data?.data === 'publish_now') {
                setUploadingFile(true);
                downloadExportedProduct({
                    exported_data_id: id,
                    per_page: perpage,
                    is_publish_now: 'publish_now'
                }, () => {
                    setUploadingFile(false);
                    navigate("/exported-data");
                }, (err) => {
                    setUploadingFile(false);
                    Swal.fire({
                        icon: "error",
                        title: "Update data fail",
                        text: "Something went wrong!",
                    }).then(() => {
                        setTimeout(() => window.scrollTo(0, 0), 300);
                    });
                });
            } else {
                Swal.fire({
                    icon: "success",
                    title: "Update data success",
                    text: "Data has been updated!",
                }).then(() => {
                    setScheduleType("");
                    setScheduleDate("");
                    setScheduleTime("");
                });
            }
        }, (err) => {
            Swal.fire({
                icon: "error",
                title: "Update data fail",
                text: "Something went wrong!",
            }).then(() => {
                setTimeout(() => window.scrollTo(0, 0), 300);
            });
        })
    }

    const disabledButton = () => {
        let isDisable = true;

        if (scheduleType === '0') {
            isDisable = false
        } else {
            if (scheduleType === '1' && scheduleDate && scheduleTime) {
                isDisable = false
            }
        }

        return isDisable
    }

    useEffect(() => {
        setLoadingData(true);
        fetchDataProduct();
    }, [perpage, page, sort]);

    return (
        <div className="content-wrapper">
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card p-4 m-4">
                                <div>
                                    <span className="font-weight-bold" style={{ color: "#262626", fontSize: 24 }}>List Exported Data</span>
                                </div>
                                <div className="row my-4">
                                    <div className="col-md-2">
                                        <div>
                                            <label>PMC</label>
                                            <input
                                                placeholder={configHeader?.item_status_pmc}
                                                className="form-control"
                                                style={{ borderRadius: 8 }}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div>
                                            <label>Website</label>
                                            <input
                                                placeholder={configHeader?.item_status_website}
                                                className="form-control"
                                                style={{ borderRadius: 8 }}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div>
                                            <label>Form Name</label>
                                            <input
                                                placeholder={configHeader?.form_name}
                                                className="form-control"
                                                style={{ borderRadius: 8 }}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div>
                                            <label>Country</label>
                                            <input
                                                placeholder={configHeader?.item_country}
                                                className="form-control"
                                                style={{ borderRadius: 8 }}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div>
                                            <label>Category</label>
                                            <input
                                                placeholder={configHeader?.filter_category}
                                                className="form-control"
                                                style={{ borderRadius: 8 }}
                                                disabled
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-2">
                                    <Table
                                        configTable={configTable}
                                        data={listData}
                                        totalData={metaList.total}
                                        currentTotalData={metaList.to}
                                        currentPageData={metaList.current_page}
                                        totalPage={metaList.total_page}
                                        perPageChange={(val) => { setPerpage(val) }}
                                        pageNumberChange={(val) => { setPage(val) }}
                                        sortData={(val) => { setSort({ field: val.key, direction: val.direction }) }}
                                        isLoading={isLoadingData}
                                    />
                                </div>
                                <div className="mt-5 d-flex justify-content-between">
                                    <button onClick={() => setOpenModalDownload(true)} type="button" className="btn btn-outline-dark">Download as CSV</button>
                                    <button onClick={() => setOpenModalPublish(true)} className="btn btn-dark">Publish to Website</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <BaseModal
                    isOpen={openModalDownload}
                    size={"modal-sm"}
                >
                    <div className="d-flex justify-content-center">
                        <div className="rounded-circle bg-light d-flex justify-content-center align-items-center" style={{ width: 64, height: 64 }}>
                            <i className="fi-rr-folder-download" style={{ fontSize: 24, color: "#959DAC" }}></i>
                        </div>
                    </div>
                    {isDownloading ? (
                        <>
                            <div className="mb-4" style={{ color: "#2C313A", textAlign: "center", fontWeight: 600 }}>Downloading Data, Please Wait!</div>
                        </>
                    ) : (
                        <>
                            <div className="mb-4" style={{ color: "#2C313A", textAlign: "center", fontWeight: 600 }}>Are you sure you want to download this data?</div>
                            <div className="d-flex justify-content-center" style={{ gap: 8 }}>
                                <button className="btn btn-outline-dark" type="button" onClick={() => setOpenModalDownload(false)}>Cancel</button>
                                <button className="btn btn-dark" type="button" onClick={() => {
                                    downloadGeneratedData();
                                }}>Download</button>
                            </div>
                        </>
                    )}

                </BaseModal>
                <BaseModal
                    isOpen={openModalPublish}
                    size={"modal-md"}
                    onClose={() => {
                        setScheduleType(null);
                        setScheduleDate(null);
                        setScheduleTime(null);
                        setOpenModalPublish(false);
                    }}
                    title={"Publish Data"}
                >
                    <div>
                        <label className="custom-radio d-flex align-items-center" style={{ gap: 8 }}>
                            <input
                                type="radio"
                                name="publish"
                                value="0"
                                checked={scheduleType === "0"}
                                onChange={(e) => setScheduleType(e.target.value)}
                            />
                            <span className="radio-indicator"></span>
                            Process now
                        </label>

                        <label className="custom-radio d-flex align-items-center" style={{ gap: 8 }}>
                            <input
                                type="radio"
                                name="publish"
                                value="1"
                                checked={scheduleType === "1"}
                                onChange={(e) => {
                                    setScheduleDate("");
                                    setScheduleTime("");
                                    setScheduleType(e.target.value);
                                }}
                            />
                            <span className="radio-indicator"></span>
                            Schedule Publish
                        </label>

                        {scheduleType === '1' && (
                            <>
                                <div className="">
                                    <Calendar id="calendar-24h" value={scheduleDate} onChange={(e) => setScheduleDate(e.value)} inline />
                                    <Select
                                        options={options}
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                borderRadius: 8,
                                                marginTop: 12
                                            }),
                                        }}
                                        name="time"
                                        isSearchable={false}
                                        isClearable={false}
                                        onChange={(val) => {
                                            // console.log(val);
                                            setScheduleTime(val.value)
                                        }}
                                        menuPlacement="top"
                                    />
                                </div>

                            </>

                        )}

                        <button
                            className="btn btn-dark mt-3"
                            type="button"
                            disabled={disabledButton()}
                            // disabled={(!scheduleDate && scheduleType === '1' && !scheduleTime) ? true : !scheduleType ? true : false}
                            onClick={() => {
                                onUpdateData();
                                // downloadGeneratedData();
                            }}
                        >
                            Publish
                        </button>
                    </div>
                </BaseModal>
                <BaseModal
                    isOpen={uploadingFile}
                    size={"modal-sm"}
                >
                    <div className="d-flex justify-content-center">
                        <div className="rounded-circle bg-light d-flex justify-content-center align-items-center" style={{ width: 64, height: 64 }}>
                            <i className="fi-rr-folder-download" style={{ fontSize: 24, color: "#959DAC" }}></i>
                        </div>
                    </div>
                    <div className="mb-4" style={{ color: "#2C313A", textAlign: "center", fontWeight: 600 }}>Publishing Data, Please Wait!</div>

                </BaseModal>
            </section>
        </div>
    )
}

export default ListGenerateProductData;
